import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import PageLayout from "../components/PageLayout"
import Seo from "../components/seo"
import Nav from "../components/Nav"

const AboutUs = ({ data, location }) => {
const siteTitle = data.site.siteMetadata?.title || `Title`

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="TheindoorGardens | Privacy Policy" description="The Indoor Gardens | Privacy Policy page"/>
      <Nav />
      <PageLayout data={data}>
        <h1 className="text-6xl pb-4 max-w-screen-sm">Privacy Policy</h1>
        <div className="BlogPostContent">
          <p>Your privacy is important to us.</p>
          <p>It is The Indoor Gardens’s policy to respect your privacy regarding any information we may collect while operating our website. Accordingly, we have developed this privacy policy in order for you to understand how we collect, use, communicate, disclose and otherwise make use of personal information. We have outlined our privacy policy below. This privacy policy discloses the privacy practices for (website address). This privacy policy applies solely to information collected by this   web site.
          </p>

          <h3>Information Collection, Use, and Sharing</h3>
          <p>The Indoor Gardens does not collect any personally identifiable information. However, we do use cookies to collect aggregate data about user habits in order to provide a better user experience. This includes, but is not limited to, metrics such as pages viewed, time spent on site, user device, and broad location information.</p>
          <p>This information is not sold to any 3rd parties. It may however be shared with various 3rd parties in an effort to provide a better user experience. For example in the process of creating marketing plans.</p>

          <h3>Email List</h3>
          <p>The indoor gardens does have a subscription based email list. This is a completely optional opt in, and is not required by any of users of the site. In the event a user does sign up we do record their email, although this is separate from our cookie tracking so we can not map these sign ups to any browsing habits.</p>
          <p>We take SPAM very seriously, and follow all legal guidelines for proper email protocol. We will never email anyone not on our list, and unsubscribing is easily done through a link at the bottom. Our contact email is always at the bottom.</p>

          <h3>Affiliate Links</h3>
          <p>Various links on our site are outbound links to 3rd parties know as affiliate links. These are links to a third party sites that are selling various items related to the page it was linked from. We receive a small portion of the sale for each item purchased when a user from out site uses one of these links.Â We do not maintain any information on who clicks these links or makes purchases. We are also not responsible for any sort of cookies or tracking on sites we link to. Please refer to their individual privacy policies for details.</p>

          <h3>Special Note About Google Advertising</h3>
          <p>Any advertisements served by Google, Inc., and affiliated companies may be controlled using cookies. These cookies allow Google to display ads based on your visits to this site and other sites that use Google advertising services. Learn how to opt out of Google’s cookie usage. As mentioned above, any tracking done by Google through cookies and other mechanisms is subject to Google’s own privacy policies.</p>
          <p>About Google advertising: What is the DoubleClick DART cookie? The DoubleClick DART cookie is used by Google in the ads served on publisher websites displaying AdSense for content ads. When users visit an AdSense publisher's website and either view or click on an ad, a cookie may be dropped on that end user's browser. The data gathered from these cookies will be used to help AdSense publishers better serve and manage the ads on their site(s) and across the web. Users may opt out of the use of the DART cookie by visiting the <a href="http://www.google.com/privacy_ads.html" rel="noreferrer" target="_blank">Google ad and content network privacy policy.</a></p>
        </div>
      </PageLayout>
    </Layout>
  )
}

export default AboutUs

export const pageQuery = graphql`
  query PrivacyPolicy
  {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
          id
        }
      }
    }
  }
`
